import axios from "axios";

// Verwende Vercel Serverless Functions (wegen CORS)
// API_URL ist leer für same-origin requests
const API_BASE_URL = process.env.REACT_APP_API_URL || "";

class MitgliedApiService {
  constructor() {
    this.api = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  // ========== KURSE ==========

  /**
   * Ruft alle Kurse ab (über Serverless Function)
   * @returns {Promise<Array>} Liste der Kurse
   */
  async getCourses() {
    try {
      const response = await this.api.get("/api/courses");
      return response.data;
    } catch (error) {
      console.error(
        "Get Courses Error:",
        error.response?.data || error.message
      );
      throw error;
    }
  }

  // ========== MITGLIEDER ==========

  /**
   * Erstellt ein neues Mitglied (über Serverless Function)
   * @param {Object} memberData - Mitgliedsdaten
   * @returns {Promise<Object>} Erstelltes Mitglied
   */
  async createMember(memberData) {
    try {
      const response = await this.api.post("/api/register-member", memberData);
      return response.data;
    } catch (error) {
      console.error(
        "Create Member Error:",
        error.response?.data || error.message
      );
      throw error;
    }
  }

  // ========== VERTRÄGE ==========

  /**
   * Ruft alle Vertragsvorlagen ab (über Serverless Function)
   * @returns {Promise<Array>} Liste der Vertragsvorlagen
   */
  async getTemplates() {
    try {
      const response = await this.api.get("/api/templates");
      return response.data;
    } catch (error) {
      console.error(
        "Get Templates Error:",
        error.response?.data || error.message
      );
      throw error;
    }
  }
}

// Singleton Instance exportieren
const mitgliedApi = new MitgliedApiService();
export default mitgliedApi;
